var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center"},[_vm._m(0),_c('AuthorForm',{attrs:{"mode":'edit'},on:{"save":_vm.UpdateAuthor,"delete":_vm.DeleteAuthor},model:{value:(_vm.author),callback:function ($$v) {_vm.author=$$v},expression:"author"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('h2',[_vm._v("Editar a autor")])])
}]

export { render, staticRenderFns }